const positions = {
  NFL: ['QB', 'RB', 'WR', 'TE', 'FLEX'],
};

export { positions };
export default positions;
  